"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactInnerHtml = _interopRequireDefault(require("react-inner-html"));

var _TerminalMessage = _interopRequireDefault(require("./defs/types/TerminalMessage"));

var _TerminalMessage2 = _interopRequireDefault(require("./defs/styles/TerminalMessage"));

var TerminalMessage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(TerminalMessage, _Component);

  function TerminalMessage() {
    (0, _classCallCheck2["default"])(this, TerminalMessage);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TerminalMessage).apply(this, arguments));
  }

  (0, _createClass2["default"])(TerminalMessage, [{
    key: "render",
    value: function render() {
      var content = this.props.content;
      var styles = {
        message: _TerminalMessage2["default"]
      };
      return this.props.dangerMode ? _react["default"].createElement("p", (0, _extends2["default"])({
        style: styles.message
      }, (0, _reactInnerHtml["default"])(content))) : _react["default"].createElement("p", {
        style: styles.message
      }, content);
    }
  }]);
  return TerminalMessage;
}(_react.Component);

exports["default"] = TerminalMessage;
(0, _defineProperty2["default"])(TerminalMessage, "propTypes", _TerminalMessage["default"]);